import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { STATUS_NEW_ADDRESS_ADDED } from '../../../constants/sessionStorage';
import { storeInSessionStorage } from '../../../util/helpers/sessionStorageHelper';
import BasicModal from '../../BasicModal/BasicModal';
import AddDeliveryAddress from './AddDeliveryAddress';
import { CustomToast } from '../../CustomToast/CustomToast';

const AddDeliveryAddressModal = ({
  isOpen,
  onClose,
  title,
  isAddingCCFlow,
  page,
}) => {
  const { t } = useTranslation();
  const [error, setError] = useState('');

  const handleNext = () => {
    if (!error && page === 'address') {
      toast.custom(() => (
        <CustomToast
          title={t('buyWizard.common.addressAdded')}
          message={t('buyWizard.common.addressAddedSuccessfully')}
        />
      ));
      storeInSessionStorage(STATUS_NEW_ADDRESS_ADDED, true);
    }
    onClose();
  };

  return (
    <BasicModal
      title={title}
      size="sm"
      isOpen={isOpen}
      close={onClose}
      closeIconVisible
    >
      <AddDeliveryAddress
        onButtonClick={onClose}
        handleNext={handleNext}
        setError={setError}
        isAddingCCFlow={isAddingCCFlow}
      />
    </BasicModal>
  );
};

AddDeliveryAddressModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  isAddingCCFlow: PropTypes.bool,
  page: PropTypes.string,
};

export default AddDeliveryAddressModal;
